var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[(_vm.imgList.length > 0)?_c('div',_vm._l((_vm.imgList),function(img){return _c('img',{staticStyle:{"width":"1000px"},attrs:{"src":img}})}),0):_c('el-empty',{attrs:{"description":"暂无数据"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }